import React from "react";
import { Link } from "gatsby";
import HTMLParser from "../../htmlParser";
const PostExcerpt = (props) => {
    const More = () => {
        return props.attributes.moreText && props.attributes.moreText.length ? (React.createElement(Link, { to: props.uri, className: "wp-block-post-excerpt__more-text", title: "Lire l'actualité " + props.title }, props.attributes.moreText)) : (React.createElement(React.Fragment, null));
    };
    if (!props.children) {
        return React.createElement(More, null);
    }
    const shortenExcerpt = (excerpt) => {
        excerpt = excerpt.replace(/\[\.\.\.\]$/g, "");
        if (excerpt.length > 150) {
            excerpt = excerpt.slice(0, 150).trim();
        }
        excerpt = excerpt + "…";
        return excerpt;
    };
    const excerpt = props.children
        .split(">")[1]
        .split("")
        .reverse()
        .join("")
        .split("<")[1]
        .split("")
        .reverse()
        .join("");
    const className = props.attributes.textAlign
        ? "wp-block-post-excerpt has-text-align-" + props.attributes.textAlign
        : "wp-block-post-excerpt";
    return (React.createElement(React.Fragment, null,
        React.createElement("p", { className: className },
            React.createElement(HTMLParser, null, shortenExcerpt(excerpt))),
        React.createElement(More, null)));
};
PostExcerpt._ges_name = "PostExcerpt";
export default PostExcerpt;
